import { http, HttpResponse } from "msw"
import type { ApiLabPerfSalesContribution } from "../../../laboratorySales/contribution"
import { labPerfSalesContributionFake } from "./financialDataLabSalesContribution.fake"

const API_DOMAIN = import.meta.env.VITE_API_DOMAIN

export const labPerfSalesContributionHandlers = [
  http.get(
    `${API_DOMAIN}/api/financial-data/laboratory/sales/upps/growth-contribution`,
    () =>
      HttpResponse.json<ApiLabPerfSalesContribution>(labPerfSalesContributionFake()),
  ),
  http.get(
    `${API_DOMAIN}/api/financial-data/laboratories/:labId/sales/upps/growth-contribution`,
    () =>
      HttpResponse.json<ApiLabPerfSalesContribution>(labPerfSalesContributionFake()),
  ),
]
